module.exports = __webpack_public_path__ + "fonts/Mukta-200-latin3.53d9ef6.woff2";